module.exports = __webpack_public_path__ + "static/media/warranty.8448ccf9.png";